import { fetchStorageProjects } from "./implementations/azureFunctionsApi";

export async function fetchProjects(accessToken) {
    return await fetchStorageProjects(accessToken);
  }